import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { PermissionEnum } from '@interfaces';
import { Location } from '@angular/common';

@Component({
  selector: 'cr-button',
  templateUrl: './cr-button.component.html',
  styleUrls: ['./cr-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CrButtonComponent implements OnInit, OnChanges {
  private readonly location = inject(Location);

  @Input() isLoading = false;
  @Input() isDisabled = false;

  @Input() routerLink: any[] = [];
  @Input() goBack = false;

  @Input() size?: 'LARGE' | 'MEDIUM' | 'SMALL' = 'MEDIUM';
  @Input() fontSize?: 'LARGE' | 'MEDIUM' | 'SMALL' = 'MEDIUM';

  @Input() requiredPermissions?: PermissionEnum[] = [];

  @Output() clicked = new EventEmitter<void>();

  public cssClasses: string[] = [];

  public ngOnInit(): void {
    this.updateCssClasses();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['size'] || changes['fontSize']) {
      this.updateCssClasses();
    }
  }

  private updateCssClasses(): void {
    this.cssClasses = [`SIZE-${this.size}`, `FONT-${this.fontSize}`];
  }

  public onClick(): void {
    if (this.isLoading) {
      return;
    }

    if (this.isDisabled) {
      return;
    }

    if (this.goBack) {
      this.location.back();
      return;
    }

    this.clicked.emit();
  }
}
